import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import Select from 'react-select';
import { userURL } from 'config'
import T from 'i18n-react'

import InputWrapper from 'components/custom/InputWrapper'
import { Flex } from 'reflexbox'
import { 
  recProjectListSelector, 
  recProjectListLoadingSelector,
  otherProjectListSelector, 
  otherProjectSelector, 
  optionSelectedSelector,
  nvbugsIdSelector,
  synopsisSelector 
} from './selectors'
import { 
  updateOtherProject, 
  fetchOtherProjectList, 
  fetchRecProjectList, 
  updateOptionSelected
} from './actions'
import RadioButton from 'components/fulcrum/radio/RadioButton'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import ProgressBar from 'components/fulcrum/progressBar/FulcrumCircularProgressBar'
import { TAG_COLORS } from 'components/display/Tag/constants'
import Tag from 'components/display/Tag'

const mapStateToProps = (state) => {
  return {
    recProjectListSource: recProjectListSelector(state),
    recProjectListLoading: recProjectListLoadingSelector(state),
    otherProjectListSource: otherProjectListSelector(state),
    otherProject: otherProjectSelector(state),
    optionSelected: optionSelectedSelector(state), 
    nvbugId: nvbugsIdSelector(state),
    synopsis: synopsisSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateOtherProject: (project) => dispatch(updateOtherProject(project)),
    updateOptionSelected: (project) => dispatch(updateOptionSelected(project)),
    fetchOtherProjectList: (query) => dispatch(fetchOtherProjectList(query)),
    fetchRecProjectList: (nvbugId) => dispatch(fetchRecProjectList(nvbugId)),
  }
}

const renderProjectHierarchyTag = (hierarchyType) => {
  const text = T.translate(`project.hierarchies.${hierarchyType}`)
  return <Flex className={styles.tagRow}>
    <Tag color={hierarchyType == 'primary' ? TAG_COLORS.GREEN : TAG_COLORS.GREY} text={text} className={styles.hierarchiesTag}/>
  </Flex>
}

class NvbugsDialogPage extends Component {

  componentDidMount() {
    const { nvbugId, fetchRecProjectList } = this.props
    if (nvbugId != '') {
      fetchRecProjectList(nvbugId)
    }
  }

  renderRecommendedProjects = () => {
    const {
      recProjectListSource,
      updateOptionSelected,
      optionSelected
    } = this.props

    const recommendedProjectListComp =  recProjectListSource.map(({ projectId, name, brand, partnerSiteName, hierarchyType }, i) => {
      const url = `/project/${projectId}/view`
      const lastCellClass = i == recProjectListSource.length - 1 ? "lastSuggRadioBtn" : ""
      return <tr key={projectId}><td><Flex>
        <RadioButton
          checked={optionSelected === parseInt(projectId)}
          onChange={() => updateOptionSelected(projectId)}
          styleName={lastCellClass}
          label={
          <Flex className={styles.checkbox}>
            <a href={url} target="_blank" className={styles.projectId}>
              {projectId}&nbsp;
            </a> 
            {renderProjectHierarchyTag(hierarchyType)}
            ({name} | {brand} | {partnerSiteName})
          </Flex>
          }
        />
    </Flex>
    </td>
    </tr>
    })

    return (recProjectListSource.length > 0 &&
      <div styleName="suggestions">
        <div styleName="suggTitle">
          Suggested Projects
        </div>
        <div styleName="suggWrapper">
          <table>
            <tbody>
              {recommendedProjectListComp}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  renderOther = () => {
    const {
      recProjectListSource,
      optionSelected,
      updateOptionSelected,
      fetchOtherProjectList,
      otherProject,
      updateOtherProject,
      otherProjectListSource
    } = this.props

    return <Flex styleName="otherWrapper">
      <RadioButton
        styleName="otherCheckbox"
        checked={optionSelected === 'other'}
        onChange={() => updateOptionSelected('other')}
      />
      <Flex styleName="otherLabel">
        <div styleName="otherText">
          {recProjectListSource && recProjectListSource.length > 0 && "Other:"}
        </div>
        <Select
          styleName="select"
          placeholder={"Begin by typing project ID or name..."}
          onInputChange={fetchOtherProjectList}
          value={otherProject}
          onChange={updateOtherProject}
          options={otherProjectListSource}
          noResultsText={'Type something, or try a different query'}
        />
      </Flex>
    </Flex>
  }

  render() {
    const {
      nvbugId,
      synopsis,
      recProjectListLoading
    } = this.props

    return (recProjectListLoading ?
      <Flex justify='center'>
        <ProgressBar/>
      </Flex>
      :
      <React.Fragment>
          <InputWrapper
            label={"NVBugs"}
            styleName={"nvbugsWrapper"}
          >
            <div styleName={"nvbugsText"}>
              <b><a target="_blank" href={`https://nvbugs/${nvbugId}`}>{nvbugId}</a> - {synopsis}</b>
            </div>
          </InputWrapper>
        <InputWrapper
            label={"Fulcrum Project"}
            styleName={"projectInputWrapper"}
            mandatory
          >
          {this.renderRecommendedProjects()}
          {this.renderOther()}
        </InputWrapper>
      </React.Fragment>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyle = CSSModules(styles)

export default compose(
  withConnect,
  withStyle
)(NvbugsDialogPage)
